import { Input, Select, Button, Flex } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { useState } from "react";

type HybridInputProps = {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  options?: Array<{ label: string; value: string | number }>;
  placeholder?: string;
  loading?: boolean;
  disabled?: boolean;
};

export default function HybridInput({
  label,
  value,
  onChange,
  options = [],
  placeholder,
  loading = false,
  disabled = false,
}: HybridInputProps) {
  const [isSelect, setIsSelect] = useState(true);

  const toggleInputType = () => {
    setIsSelect(!isSelect);
  };

  // Trova il label corrispondente al value se è un ID nelle options
  const matchByValue = options.find(opt => String(opt.value) === String(value));
  // Trova l'option per label se il value è una stringa testuale
  const matchByLabel = options.find(opt => opt.label === value);
  
  const displayValue = matchByValue?.label || matchByLabel?.label || value;
  const selectValue = matchByValue?.value || matchByLabel?.value || value;

  return (
    <div className="form-field">
      <Flex justify="space-between" align="center" className="mb-2">
        <label className="field-label">
          <strong>{label}</strong>
        </label>
        <Button
          type="text"
          size="small"
          icon={<SwapOutlined />}
          onClick={toggleInputType}
          disabled={disabled}
        >
          {isSelect ? "Input" : "Select"}
        </Button>
      </Flex>
      {isSelect ? (
        <Select
          size="large"
          className="w-100 custom-input"
          placeholder={placeholder || `Seleziona ${label}`}
          value={selectValue || undefined}
          onChange={(val, opt) => {
            if (val == null) return onChange("");
            const selectedLabel = Array.isArray(opt) ? String(val) : (opt?.label ?? String(val));
            onChange(String(selectedLabel));
          }}
          options={options}
          loading={loading}
          disabled={disabled}
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
      ) : (
        <Input
          size="large"
          className="custom-input"
          placeholder={placeholder || `Inserisci ${label}`}
          value={displayValue}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
      )}
    </div>
  );
}
